<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
#main
	height:100%
	background:#ffffff
	overflow-y:auto
	.tables
		padding-top:10px
	.btn
		position: fixed
		top:100px
		right:100px
		z-index:100
	.dialogfp
		display:flex
		align-items:center
		position:relative
		.imglist
			position:relative
			display:flex
			flex-direction:column
			align-items:center
			img
				width:45px
				height:45px
				border-radius:50%
			.imgname
				font-size:12px
				color:#999999
				heigth:20px
				line-height:20px
			i
				width:10px
				height:10px
				position:absolute
				top:-12px
				right:-2px
		.userlist
			color:#1890ff
			font-size:14px
			margin-left:20px
			cursor:pointer
		.showlist
			position:absolute
			top:0px
			left:150px
			width:240px
			height:350px
			background:#ffffff
			box-shadow: 0 0 18px rgba(153,153,153,0.56)
			.show-title
				color:#333333
				font-size:16px
				margin-left:20px
			.show-input
				padding:0 15px
			.show-list
				height:220px
				overflow-y:auto
				overflow-x:hidden
				.list-title
					text-align:center
				.list-radio
					line-height:0px
					.list-radio-list
						display:flex
						align-items:center
						padding:5px 15px
						.list-radios
							display:flex
							align-items:center
							img
								width:30px
								height:30px
							.list-radios-name
								font-size:12px
								color:#999999
								margin-left:5px
			.list-btn
				text-align:center
				border-top:1px solid #eeeeee
				padding-top:5px
				
</style>

<template>
  <div id="main">
    <div class="btn">
  		<el-button style="background:#005474;color:#fff;" round size="mini" @click="showAdd = true">添加工号</el-button>
  	</div>
   	<div class="tables">
	  	<el-table :data="accountList" size="small" stripe v-loading="listLoading"  :header-cell-style="{background:'#005474',color:'#fff'}">
	  		<el-table-column label="客服号" prop="job_number" align="center"></el-table-column>
	  		<el-table-column label="绑定个人账号" align="center">
	  			<template slot-scope="scoped">
	  				<div v-if="scoped.row.user_name == null ">--</div>
	  				<div v-else>{{scoped.row.user_name}}</div>
	  			</template>
	  		</el-table-column>
	  		<el-table-column label="账号状态" align="center">
	  			<template slot-scope="scoped">
	  				<div v-if="scoped.row.status == 0">离线</div>
	  				<div v-else-if = "scoped.row.status == 1">在线</div>
	  			</template>
	  		</el-table-column>
	  		<el-table-column width="700px"></el-table-column>
	  		<el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
	  		<el-table-column label="操作" align="center">
	  			<template slot-scope="scope">
	  				<el-button type="text" @click="edit(scope.row)" style="color:#005474">编辑</el-button>
	  			</template>
	  		</el-table-column>
	  	</el-table>
  	</div>

  	<div class="commonpagenav" v-if="last_page > 1">
  		<el-pagination background :current-page.sync="pageIndex" :page-size="perpage" @current-change="handleCurrentChange" layout="prev, pager, next, total" :total="total"></el-pagination>
  	</div>

  	<el-col>
  		<el-dialog title="添加工号" :visible.sync="showAdd" width="450px" @close="closeDialog('addForm')">
  			<el-form label-width="100px" :model="addForm" :rules="addrules" ref="addForm">
  				<el-form-item label="工作编号 :" prop="job_number">
	                <el-input size="small" placeholder="请输入工作编号" v-model.number="addForm.job_number" ></el-input>
	            </el-form-item>
  			</el-form>
  			<span slot="footer" class="dialog-footer">
	            <el-button size="mini" @click="showAdd = false">取消</el-button>
  				<el-button size="mini" type="primary" @click="subAdd('addForm')">确定</el-button>
	        </span>
  		</el-dialog>
  	</el-col>

  	<el-col>
  		<el-dialog title="编辑工号" :visible.sync="showEdit" width="450px" @close="closeDialog('ruleForm')">
  			<el-form label-width="100px" :model="editForm" :rules="rules" ref="ruleForm">
  				<el-form-item label="工作编号 :">
	                <el-input size="small" placeholder="请输入工作编号" v-model.number="editForm.job_number" disabled></el-input>
	            </el-form-item>
	            <el-form-item label="工作状态 :">
	                <el-select size="small" v-model="editForm.status">
	                	<el-option v-for="(item,index) in staList" :key="item.value" :label="item.name" :value="item.value"></el-option>
	                </el-select>
	            </el-form-item>
	            <el-form-item label="分配客服 :">
	                <div class="dialogfp">
	                    <div class="imglist" v-if="editForm.user_id">
	                		<img :src="$avatarHash(editForm.user_id)">
	                		<div class="imgname">{{editForm.user_name}}</div>
	                		<!-- <i class="iconfont iconicon_roundclose_fill" @click="delUser"></i> -->
	                	</div>
	                	<div class="userlist" @click.stop="showUser = !showUser">
	                		<span>选择/更换客服</span>
	                	</div>
	                	<div v-show="showUser" class="showlist" v-clickOutSide = "outCheck">
                			<div class="show-title">选择人员</div>
                			<div class="show-input">
                				<el-input size="small" placeholder="输入名称搜索用户" v-model="searchUser" @keyup.enter.native="searchuser">
                					<el-button size="small" slot="append" icon="el-icon-search" @click="searchuser"></el-button>
                				</el-input>
                			</div>
                			<div class="show-list">
                				<div class="list-radio" v-if="serchList">
                					<el-radio-group v-model="selUser" size="small">
                						<el-radio v-for="(item,index) in serchList" :key="item.user_id" :label='`{"fid": "${item.user_id}","name": "${item.name}"}`' class="list-radio-list"  v-if="item.identity != '律师'">
                							<div class="list-radios">
	                							<img :src="$avatarHash(item.user_id)">
	                							<div class="list-radios-name">{{item.name}}</div>
                							</div>
                						</el-radio>
                					</el-radio-group>
                				</div>
                				<div class="list-title">关注列表</div>
                				<div class="list-radio">
                					<el-radio-group v-model="selUser" size="small">
                						<el-radio v-for="(item,index) in gzList" :key="item.fid" :label='`{"fid": "${item.fid}","name": "${item.real_name || item.name}"}`' class="list-radio-list">
                							<div class="list-radios">
	                							<img :src="$avatarHash(item.fid)">
	                							<div class="list-radios-name">{{item.remark? `${item.remark}(${item.name})`: item.name}}</div>
                							</div>
                						</el-radio>
                					</el-radio-group>
                				</div>
                			</div>
                			<div class="list-btn">
            					<el-button size="small" type="primary" @click="subUser">确定</el-button>
            				</div>
                		</div>
	                </div>
	            </el-form-item>
  			</el-form>
  			<span slot="footer" class="dialog-footer">
	            <el-button size="small" @click="showEdit = false">取 消</el-button>
	            <el-button type="primary" size="small" @click="subEdit()">确 定</el-button>
	        </span>
  		</el-dialog>
  	</el-col>
  </div>
</template>

<script>
export default {
	data() {
		var checkjobnum = (rule, value, callback) => {
	        if (!value) {
	          return callback(new Error('工号不能为空'));
	        }
	        if (!Number.isInteger(value)) {
	        	callback(new Error('请输入数字值'));
	        } else {
	        	callback();
	        }
	    };
		return {
			accountList:[],
			listLoading:false,
			showAdd:false,
			addForm:{
				job_number:''
			},
			addrules:{
				job_number:[
					{ required: true, validator: checkjobnum, trigger: 'blur' },
				]
			},
			addnum:'',
			total:0,
			last_page:'',
			pageIndex: 1,
      		perpage: 20,
			showEdit:false,
			editForm:{
				job_number:'',
				status:'',
				user_id:'',
				user_name:''
			},
			rules:{
				
			},
			staList:[
			    {name:'在线',value:1},{name:'离线',value:0}
			],
			showUser:false,
			searchUser:'',
			selUser:'',
			gzList:[],
			serchList:[]
		}
	},
	computed: {
		
    },
	created() {

	},
	mounted() {
		this.getList();		
	},
	methods: {
		//获取客服列表
		getList(){
			this.listLoading = true
		    let url = 'consultcenter/supportstaffmanage/list'
		    let params = {
		        page: this.pageIndex,
		        perpage: this.perpage,
		    }
		    this.$ajax('get', url, params, res => {
		        if (res.data.data) {
		          this.accountList = res.data.data;
		          this.total = res.data.total;
		          this.last_page = res.data.last_page;
		        } else {
		          this.total = 0
		        }
		        this.listLoading = false
		    })
		},
		//添加客服
		subAdd(formName){
			this.$refs[formName].validate((valid) =>{
				if (valid){
					let url = 'consultcenter/supportstaffmanage/add'
					let params = {
						job_number : this.addForm.job_number,
					}
					this.$ajax('post' , url , params, res => {
						if (res.retcode === 0) {
				        	this.$messageAlert({
					            type: 'success',
					            text: '添加成功',
					            autoClose: true,
					            close: () => {
					            }
					        });
					        this.showAdd = false;
					        this.pageIndex = 1;
					        this.getList();
				        } else {
				          this.$message.error(res.data.errmsg)
				        }
					})
				}
			})
		},
		//显示编辑
		edit(item){
			this.showEdit = true;
			this.editForm = {
				job_number:item.job_number,
				status:item.status,
				user_id:item.user_id,
				user_name:item.user_name
			};
			this.getUsers();
		},
		//删除已选中的分配客服
		delUser(){
			this.editForm.user_name = '';
			this.editForm.user_id = '';
		},
		//关闭成员选择
		outCheck(){
			this.showUser = false;
			this.serchList = [];
			this.searchUser ='';
			this.selUser = '';
		},
		//获取关注用户列表
		getUsers(){
			let id = this.$store.state.mineInfo.id;
			console.log('aaaaaa',this.$store.state.mineInfo)
			let url = '/user/usersinfollowclassify'
			this.$ajax('get', url, (data) => {
                this.gzList = data.data
            });
		},
		//搜索用户
		searchuser(){
			if (this.searchUser == '' || this.searchUser == null) {
                this.serchList=[]
                return false
            }
			let url = `search/user/${this.searchUser}`;
			let option = {
                page: 1,
                perpage: 50
            }
            this.$ajax('get', url, option, res => {
                if (res.retcode === RETCODE_OK) {
                    this.serchList = res.data;
                }else{
                	this.$message.error(res.data.errmsg)
                }
            })
		},
		//选中要分配的客服
		subUser(){
			let user = JSON.parse(this.selUser);
			this.editForm.user_id = user.fid;
			this.editForm.user_name = user.name;
			this.outCheck();
		},
		//提交编辑
		subEdit(){
			let url = 'consultcenter/supportstaffmanage/edit';
			let option = {
				job_number:this.editForm.job_number,
				status:this.editForm.status,
				user_id:this.editForm.user_id
			};
			if(this.editForm.user_id == null){
				this.$message.error('请先分配客服')
			}else{
				this.$ajax('post',url,option,res => {
					if(res.retcode === RETCODE_OK){
						this.$messageAlert({
				            type: 'success',
				            text: '修改成功',
				            autoClose: true,
				            close: () => {
				            }
				        });
				        this.showEdit = false;
				        this.pageIndex= 1;
				        this.getList();
					}else{
						this.$message.error(res.data.errmsg)
					}
				})
			}
		},
		//分页
		handleCurrentChange(val) {
	        this.pageIndex = val;
	        this.getList()
	    },
	    //关闭dialog事件
	    closeDialog(formName){
	    	 this.$refs[formName].resetFields();
	    },
	},
	watch: {
		searchUser(v){
			this.searchuser();
		}
	},
	filters: {

	},
	components: {
      
  },
}
</script>




// WEBPACK FOOTER //
// src/components/consult/customer/accountManage.vue